/**
 * 异步获取图片宽高
 * @param src
 * @returns {Promise<unknown>}
 */
export function getImageSize (src) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.src = src
    img.onload = function () {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight
      })
    }
  })
}
